<script setup lang="ts">
defineEmits(["close"]);
defineProps<{
  close: () => void;
}>();
const { trackEvent } = useGAnalytics();
const { toggleBlockScroll } = useBlockScroll();
const userStore = useUserStore();

onMounted(() => {
  toggleBlockScroll(true);
});
</script>

<template>
  <div
    v-if="userStore.isLoggedIn"
    class="bg-secondary-800 flex gap-2 items-center px-4 py-2 md:p-4 border-t md:border md:border-b-0 border-secondary-500 md:rounded-t-xl shri">
    <CommonUserProfilePicture
      :profile-picture="userStore.profilePicture"
      size="custom"
      custom-class="w-14 h-14" />
    <div class="flex-1">
      <CommonUsername
        :username="{
          displayName: userStore.displayName,
          tagline: userStore.tagline,
          roles: userStore.roles,
        }"
        :show-tooltip="false" />
      <p class="text-neutral-300 text-xs truncate max-w-52">
        {{ userStore.email }}
      </p>
    </div>
  </div>
  <HeaderAccountUserMenuDropdownItems @close="close" />
  <div
    v-if="userStore.accountAddress"
    class="h-14 mx-5 mb-5 bg-secondary-900 border-2 border-secondary-500 flex justify-center items-center gap-2 md:hidden">
    <div class="flex items-center justify-center gap-2">
      <BaseIcon
        name="GFAL_token"
        :alt="$t('main.imageAltTexts.GFALTokenLogo')"
        class="w-8" />
      <p
        class="peer text-neutral-200 font-semibold text-xl"
        @click="$emit('close'), trackEvent('dropdown_balance')">
        {{ userStore.showBalance ? roundNum(userStore.balance) : "•••••••.••" }}
      </p>
    </div>
  </div>
</template>
